import { formatConfirmationDate } from '../../helpers/confirmation-display';
import type { TimelinePresentation } from '../../types/presentation.types';

export function AgentTimeline({ block }: { block: TimelinePresentation }) {
  return (
    <div className='w-full max-w-full'>
      {block.title && (
        <div className='mb-2 text-xs font-medium text-gray-700'>
          {block.title}
        </div>
      )}
      <ol className='flex flex-col'>
        {block.items.map((item, i) => {
          const isLast = i === block.items.length - 1;
          return (
            <li
              key={item.id ?? i}
              className='flex gap-3'
            >
              {/* Marker + connector rail */}
              <div className='flex flex-col items-center'>
                <span className='mt-1 size-2 shrink-0 rounded-full bg-primary-1000' />
                {!isLast && <span className='w-px flex-1 bg-gray-200' />}
              </div>
              <div className={isLast ? 'pb-0' : 'pb-4'}>
                <div className='flex flex-wrap items-baseline gap-2'>
                  <span className='text-xs font-medium text-gray-900'>
                    {item.title}
                  </span>
                  {item.timestamp && (
                    <span className='text-xs text-gray-400'>
                      {formatConfirmationDate(item.timestamp)}
                    </span>
                  )}
                </div>
                {item.description && (
                  <p className='mt-0.5 text-xs text-gray-600'>
                    {item.description}
                  </p>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
